import { makeStyles } from 'tss-react/mui';

const name = 'GRPCCodeExample';

export const useGRPCCodeExampleStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  box: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(3),

    padding: theme.spacing(2, 2, 4, 4),

    borderRadius: theme.shape.borderRadius,

    backgroundColor: theme.palette.surface.primary,

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1, 2, 2),

      borderRadius: theme.shape.borderRadiusMd,
    },
  },
  code: {
    overflowX: 'scroll',

    margin: 0,
    paddingTop: theme.spacing(2),

    lineHeight: 1.4,
    fontSize: 14,

    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(1),

      lineHeight: 1.35,
      fontSize: 12,
    },
  },
  codeScrollbar: {
    marginBottom: -3, // to compensate for scrollbar height

    '&::-webkit-scrollbar': {
      width: 3,
      height: 3,
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.grey[300],
      borderRadius: 2,
    },
  },
  copyIcon: {
    '&&': {
      fontSize: 24,
    },
  },
}));
